export const adminConfig = {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL || "http://localhost:3000",

  auth: {
    headerName: "x-admin-token",
    tokenStorageKey: "ADMIN_TOKEN",
    verifyEndpoint: "/api/admin/unavailable",
  },

  unavailable: {
    getEndpoint: "/api/admin/unavailable",
    saveEndpoint: "/api/admin/unavailable",
    allTimeSlots: [
      "09:00(線上)",
      "14:00(線上)",
      "17:00(線上)",
      "19:00(線上)",
      "22:00(線上)",
    ],
  },

  bookings: {
    listEndpoint: "/api/admin/bookings",
    updateStatusEndpoint: (id) =>
      `/api/admin/bookings/${encodeURIComponent(id)}/status`,
    deleteEndpoint: (id) => `/api/admin/bookings/${encodeURIComponent(id)}`,

    statusOptions: [
      { value: "pending", label: "待處理" },
      { value: "done", label: "已完成" },
      { value: "canceled", label: "已取消" },
    ],

    services: [
      { id: "name", title: "姓名學" },
      { id: "name_family", title: "姓名鑑定全家餐" },
      { id: "ziwei", title: "紫微斗數" },
      { id: "bazi", title: "四柱八字" },
      { id: "liuyao", title: "六爻占卜" },
      { id: "fengshui", title: "風水堪輿" },
    ],
  },

  ui: {
    title: "後台管理",
    subtitle: "在這裡可以設定「休息 / 不開放時段」，以及管理所有顧客預約。",
  },
};
